/* ==========================================================================
   media-gallery.js — galería de medios de las tarjetas de producto
   --------------------------------------------------------------------------
   Estructura original (PageFly ProductMedia3):
     .pf-product-media (pf-262_)
       └ .pf-list-wrap.product-media2-inner.product-media-loading
           └ .pf-media-frame.pmw.pf-main-media-wrapper
               └ .pf-media-main (pf-263_)   ← `container: main-media / inline-size`
                   └ .pf-media-inner
                       └ .pf-media-slider
                           └ .pf-slide-main-media[data-media-id] × N
                               └ img.pf-img.active

   En el sitio real el runtime de PageFly:
     1. quita `product-media-loading` una vez montada la galería,
     2. dimensiona cada `.pf-slide-main-media` al 100 % del visor
        (replicado en css/runtime.css),
     3. marca `.active` sobre la imagen visible,
     4. inyecta las flechas (lo hace slider.js),
     5. navega a `data-href` al hacer clic — `clickAction: 1` en elementData
        (lo hace interactions.js vía `[data-href]`).
   ========================================================================== */
(function () {
  'use strict';

  function initGallery(slider) {
    var slides = slider.querySelectorAll('.pf-slide-main-media');
    if (!slides.length) return;

    function markActive() {
      var box = slider.getBoundingClientRect();
      var mid = box.width / 2;
      for (var i = 0; i < slides.length; i++) {
        var r = slides[i].getBoundingClientRect();
        var visible = (r.left - box.left) <= mid && (r.right - box.left) > mid;
        var img = slides[i].querySelector('img');
        if (img) img.classList.toggle('active', visible);
      }
    }

    var raf = null;
    slider.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; markActive(); });
    }, { passive: true });

    markActive();
  }

  function init() {
    /* estado de carga: el runtime original lo retira al montar */
    document.querySelectorAll('.product-media-loading').forEach(function (el) {
      el.classList.remove('product-media-loading');
    });
    document.querySelectorAll('.pf-media-slider').forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
